[
  [1684627200000, 1818.9695295035847],
  [1684713600000, 1804.9290671072804],
  [1684800000000, 1818.4014644980855],
  [1684886400000, 1854.1931182731782],
  [1684972800000, 1800.736010305837],
  [1685059200000, 1805.8057604056937],
  [1685145600000, 1828.9565366197276],
  [1685232000000, 1830.3066513168976],
  [1685318400000, 1913.8162493165785],
  [1685404800000, 1893.7142740897043],
  [1685491200000, 1901.078310164527],
  [1685577600000, 1874.694885027078],
  [1685664000000, 1861.7253869476187],
  [1685750400000, 1907.2123218510073],
  [1685836800000, 1892.0781764647577],
  [1685923200000, 1893.178280382087],
  [1686009600000, 1813.6816549003997],
  [1686096000000, 1883.2425846255821],
  [1686182400000, 1832.3204025034538],
  [1686268800000, 1846.0300017820573],
  [1686355200000, 1839.2080126581927],
  [1686441600000, 1754.6732284106363],
  [1686528000000, 1751.7245965042496],
  [1686614400000, 1742.5960525666158],
  [1686700800000, 1736.7894371674618],
  [1686787200000, 1650.6766675535464],
  [1686873600000, 1664.9774623940225],
  [1686960000000, 1716.3772810928574],
  [1687046400000, 1726.3728097349979],
  [1687132800000, 1719.2731615068672],
  [1687219200000, 1734.7931034426633],
  [1687305600000, 1790.1904407317654],
  [1687392000000, 1892.899571916819],
  [1687478400000, 1874.1779470167141],
  [1687564800000, 1891.3450080216778],
  [1687651200000, 1875.0599619284883],
  [1687737600000, 1899.1473121046054],
  [1687824000000, 1859.8024196427973],
  [1687910400000, 1890.0129037837075],
  [1687996800000, 1828.4583364007253],
  [1688083200000, 1853.4452458749938],
  [1688169600000, 1934.0457142617754],
  [1688256000000, 1924.5672408676514],
  [1688342400000, 1933.9598813832074],
  [1688428800000, 1953.7811276489165],
  [1688515200000, 1937.0004255391354],
  [1688601600000, 1910.5052605097412],
  [1688688000000, 1855.4747836363103],
  [1688774400000, 1869.317187141899],
  [1688860800000, 1864.8685919146383],
  [1688947200000, 1866.9167424803986],
  [1689033600000, 1875.2742726720535],
  [1689120000000, 1875.8658719294942],
  [1689206400000, 1873.5068153773982],
  [1689292800000, 2003.253616074307],
  [1689379200000, 1935.9402407442033],
  [1689465600000, 1931.389384157173],
  [1689552000000, 1923.0359898160434],
  [1689638400000, 1912.1228355695634],
  [1689724800000, 1897.199112644643],
  [1689811200000, 1889.2238055517662],
  [1689897600000, 1891.0145054589366],
  [1689984000000, 1891.4724028266849],
  [1690070400000, 1858.3111958083061],
  [1690156800000, 1887.8269808569783],
  [1690243200000, 1850.431150587501],
  [1690329600000, 1857.5965927470297],
  [1690416000000, 1871.5331057115002],
  [1690502400000, 1858.77702138144],
  [1690588800000, 1874.6939950760675],
  [1690675200000, 1880.9180765299413],
  [1690761600000, 1861.8699097932104],
  [1690848000000, 1857.2761957628516],
  [1690934400000, 1869.7451086679923],
  [1691020800000, 1838.0119518760303],
  [1691107200000, 1835.7013026752861],
  [1691193600000, 1828.4611937761101],
  [1691280000000, 1835.0705778421902],
  [1691366400000, 1826.7067792702178],
  [1691452800000, 1826.9334855730522],
  [1691539200000, 1856.8441445120409],
  [1691625600000, 1855.8907273266504],
  [1691712000000, 1850.8769886993493],
  [1691798400000, 1847.5418351143242],
  [1691884800000, 1848.505238656101],
  [1691971200000, 1839.5128095422053],
  [1692057600000, 1843.5133910053466],
  [1692144000000, 1826.9131281594616],
  [1692230400000, 1809.4604742643007],
  [1692316800000, 1675.8621709457839],
  [1692403200000, 1660.6791095302815],
  [1692489600000, 1669.233454808334],
  [1692576000000, 1682.461825140931],
  [1692662400000, 1666.8404654985097],
  [1692748800000, 1635.191294137295],
  [1692835200000, 1679.123993491918],
  [1692921600000, 1658.3996538851384],
  [1693008000000, 1653.4293196573105],
  [1693094400000, 1645.9049996794286],
  [1693180800000, 1656.9310584772875],
  [1693267200000, 1653.198566161456],
  [1693353600000, 1730.1902578762465],
  [1693440000000, 1705.1081032258105],
  [1693526400000, 1645.1815254166893],
  [1693612800000, 1630.6058904999302],
  [1693699200000, 1636.1621989563407],
  [1693785600000, 1635.4030431134638],
  [1693872000000, 1630.6275466678564],
  [1693958400000, 1633.077003857269],
  [1694044800000, 1632.9024163463462],
  [1694131200000, 1646.3050827277937],
  [1694217600000, 1636.354258593187],
  [1694304000000, 1634.4459462937054],
  [1694390400000, 1617.486179584741],
  [1694476800000, 1549.8934231592937],
  [1694563200000, 1594.9745013935253],
  [1694649600000, 1607.736697039678],
  [1694736000000, 1626.436340686946],
  [1694822400000, 1641.9347582842215],
  [1694908800000, 1634.4198849990876],
  [1694995200000, 1622.47877705834],
  [1695081600000, 1636.6346089914616],
  [1695168000000, 1643.69841825706],
  [1695254400000, 1621.5329552921687],
  [1695340800000, 1583.824247006604],
  [1695427200000, 1593.47015355046],
  [1695513600000, 1593.1799744357936],
  [1695600000000, 1580.4777945863666],
  [1695686400000, 1588.4711834402021],
  [1695772800000, 1592.4861256187212],
  [1695859200000, 1597.4168102614992],
  [1695945600000, 1652.196396535431],
  [1696032000000, 1667.9888487709648],
  [1696118400000, 1670.9989557571496],
  [1696204800000, 1733.8180349156962],
  [1696291200000, 1665.2764251106737],
  [1696377600000, 1656.3220030722484],
  [1696464000000, 1648.1933725281149],
  [1696550400000, 1612.9948892467298],
  [1696636800000, 1646.393402292886],
  [1696723200000, 1635.0828552489816],
  [1696809600000, 1634.2216551482747],
  [1696896000000, 1580.1777604853462],
  [1696982400000, 1567.4582264892952],
  [1697068800000, 1564.9162030441025],
  [1697155200000, 1536.812804708381],
  [1697241600000, 1550.9668729956575],
  [1697328000000, 1555.4562079337263],
  [1697414400000, 1557.7608092483292],
  [1697500800000, 1601.2321896426622],
  [1697587200000, 1565.060587724063],
  [1697673600000, 1564.0711872017082],
  [1697760000000, 1568.3746833451946],
  [1697846400000, 1603.9099355967796],
  [1697932800000, 1629.2955293417388],
  [1698019200000, 1664.5706380939323],
  [1698105600000, 1764.9303085804013],
  [1698192000000, 1784.773410988584],
  [1698278400000, 1785.555149097494],
  [1698364800000, 1804.1617691384567],
  [1698451200000, 1780.5704118622923],
  [1698537600000, 1776.3535658345309],
  [1698624000000, 1798.1654135455137],
  [1698710400000, 1809.639301345049],
  [1698796800000, 1816.803148929945],
  [1698883200000, 1846.482230513473],
  [1698969600000, 1800.9071798806326],
  [1699056000000, 1834.1730567056395],
  [1699142400000, 1855.454385276214],
  [1699228800000, 1895.9380660074166],
  [1699315200000, 1898.5182255844231],
  [1699401600000, 1887.315321843377],
  [1699488000000, 1891.491779137154],
  [1699574400000, 2128.6095039438633],
  [1699660800000, 2078.853466304058],
  [1699747200000, 2052.994586063755],
  [1699833600000, 2046.0870799735535],
  [1699920000000, 2060.5328561356905],
  [1700006400000, 1980.5154306252414],
  [1700092800000, 2061.635532253063],
  [1700179200000, 1962.243839589886],
  [1700265600000, 1956.5174321166123],
  [1700352000000, 1962.6305661102026],
  [1700438400000, 2011.1267210635335],
  [1700524800000, 2022.3881475372507],
  [1700611200000, 1940.4448103653],
  [1700697600000, 2065.9414413104028],
  [1700784000000, 2062.269551857858],
  [1700870400000, 2080.8517575183496],
  [1700956800000, 2085.426621540017],
  [1701043200000, 2064.0742181655314],
  [1701129600000, 2030.000505811856],
  [1701216000000, 2048.535256652576],
  [1701302400000, 2025.9373276989],
  [1701388800000, 2051.7567179446996],
  [1701475200000, 2085.7123613209396],
  [1701561600000, 2165.297880951399],
  [1701648000000, 2190.7040403697074],
  [1701734400000, 2242.961542677477],
  [1701820800000, 2294.0951698534136],
  [1701907200000, 2232.0254402104606],
  [1701993600000, 2354.386930946088],
  [1702080000000, 2359.8890564833255],
  [1702166400000, 2341.07248115182],
  [1702252800000, 2352.0987284889175],
  [1702339200000, 2222.3468384000316],
  [1702425600000, 2200.3337161808727],
  [1702512000000, 2260.8823525751127],
  [1702598400000, 2317.4650743736975],
  [1702684800000, 2219.9516178764084],
  [1702771200000, 2227.936447135476],
  [1702857600000, 2199.5401211883855],
  [1702944000000, 2216.929013563485],
  [1703030400000, 2176.8394126574362],
  [1703116800000, 2198.421404460542],
  [1703203200000, 2236.186961753279],
  [1703289600000, 2327.048962711535],
  [1703376000000, 2310.955662998272],
  [1703462400000, 2264.911143671657],
  [1703548800000, 2273.6326121146535],
  [1703635200000, 2230.8761843957795],
  [1703721600000, 2376.771249284193],
  [1703808000000, 2345.2607087446872],
  [1703894400000, 2299.5262072752594],
  [1703980800000, 2294.3440063451],
  [1704067200000, 2279.9410085689606],
  [1704153600000, 2350.0262860085095],
  [1704240000000, 2360.7821195890947],
  [1704326400000, 2211.1708278638766],
  [1704412800000, 2270.977439333732],
  [1704499200000, 2267.087035484658],
  [1704585600000, 2241.5108270042424],
  [1704672000000, 2220.151561688879],
  [1704758400000, 2331.6603294356382],
  [1704844800000, 2341.160624264102],
  [1704931200000, 2588.769163919145],
  [1705017600000, 2618.3298618964914],
  [1705104000000, 2524.5016938912413],
  [1705190400000, 2575.9247354333543],
  [1705276800000, 2477.9374784307734],
  [1705363200000, 2515.3199803936955],
  [1705449600000, 2589.4826316304293],
  [1705536000000, 2528.3287854519394],
  [1705622400000, 2467.3289785137254],
  [1705708800000, 2489.6180646533794],
  [1705795200000, 2470.2636151036777],
  [1705881600000, 2454.909543339834],
  [1705968000000, 2307.5870034987734],
  [1706054400000, 2241.942776155338],
  [1706140800000, 2236.7393130974074],
  [1706227200000, 2219.6145274459245],
  [1706313600000, 2268.8707315074744],
  [1706400000000, 2267.907851752534],
  [1706486400000, 2257.0544646456055],
  [1706572800000, 2314.59472753004],
  [1706659200000, 2344.001400019654],
  [1706745600000, 2282.4858670158414],
  [1706832000000, 2301.737299308667],
  [1706918400000, 2307.4329984830933],
  [1707004800000, 2294.7159248044077],
  [1707091200000, 2290.084492877089],
  [1707177600000, 2298.669906674278],
  [1707264000000, 2372.7608787345252],
  [1707350400000, 2424.0730404652095],
  [1707436800000, 2420.9685614791365],
  [1707523200000, 2487.8508971967804],
  [1707609600000, 2499.4921841564314],
  [1707696000000, 2505.076808453919],
  [1707782400000, 2657.990407976775],
  [1707868800000, 2641.5360974921623],
  [1707955200000, 2780.372974906562],
  [1708041600000, 2826.821475855177],
  [1708128000000, 2807.3717030539606],
  [1708214400000, 2788.561332499608],
  [1708300800000, 2874.945276040071],
  [1708387200000, 2943.723084777655],
  [1708473600000, 3015.438952062055],
  [1708560000000, 2977.0820166829903],
  [1708646400000, 2974.1315861319913],
  [1708732800000, 2926.2859129063513],
  [1708819200000, 2988.317384063568],
  [1708905600000, 3113.4082982877167],
  [1708992000000, 3173.62994683714],
  [1709078400000, 3242.0476538223666],
  [1709164800000, 3380.8039555421246],
  [1709251200000, 3347.6904724233455],
  [1709337600000, 3431.75199772032],
  [1709424000000, 3421.89214692414],
  [1709510400000, 3487.190931866777],
  [1709596800000, 3634.311067557102],
  [1709683200000, 3581.5348849085663],
  [1709769600000, 3822.365818156151],
  [1709856000000, 3861.9009990137733],
  [1709942400000, 3893.6138841967036],
  [1710028800000, 3916.041187699099],
  [1710115200000, 3887.473104733291],
  [1710201600000, 4070.6040749869985],
  [1710288000000, 3978.685771378112],
  [1710374400000, 4007.9121260756656],
  [1710460800000, 3879.038366642958],
  [1710547200000, 3738.381184462065],
  [1710633600000, 3514.222472178163],
  [1710720000000, 3643.280347379834],
  [1710806400000, 3525.8936406700236],
  [1710892800000, 3171.293836639821],
  [1710979200000, 3515.6884318548646],
  [1711065600000, 3493.4304387798707],
  [1711152000000, 3322.891277320318],
  [1711238400000, 3353.371241538487],
  [1711324800000, 3454.257071389558],
  [1711411200000, 3588.493402189288],
  [1711497600000, 3591.5485279028403],
  [1711584000000, 3505.2181161826984],
  [1711670400000, 3560.26151146781],
  [1711756800000, 3516.096057627979],
  [1711843200000, 3507.6606559474685],
  [1711929600000, 3644.767598784896],
  [1712016000000, 3508.2477201085417],
  [1712102400000, 3274.901203544406],
  [1712188800000, 3316.6829546775257],
  [1712275200000, 3332.089836615912],
  [1712361600000, 3320.2815889834437],
  [1712448000000, 3362.838907503287],
  [1712534400000, 3453.4361261792887],
  [1712620800000, 3695.239391141908],
  [1712707200000, 3503.6535996841044],
  [1712793600000, 3539.7630640649413],
  [1712880000000, 3508.5784984486436],
  [1712966400000, 3245.5005926983195],
  [1713052800000, 3022.0057852476043],
  [1713139200000, 3157.683765827796],
  [1713225600000, 3101.190735674771],
  [1713312000000, 3083.7060147660673],
  [1713398400000, 2982.6157347097997],
  [1713484800000, 3064.9115922294277],
  [1713571200000, 3065.682561565907],
  [1713657600000, 3152.1915066519473],
  [1713744000000, 3147.13775429932],
  [1713830400000, 3199.769589894069],
  [1713916800000, 3218.9672686428075],
  [1714003200000, 3138.814357009402],
  [1714089600000, 3157.6193174815944],
  [1714176000000, 3131.4192197400516],
  [1714262400000, 3259.2522227654413],
  [1714348800000, 3259.503404256033],
  [1714435200000, 3213.6890004948136],
  [1714521600000, 3018.549635877818],
  [1714608000000, 2976.0902075157046],
  [1714694400000, 2988.5486490452654],
  [1714780800000, 3102.1512923656555],
  [1714867200000, 3115.0233215730136],
  [1714953600000, 3136.57511039041],
  [1715040000000, 3064.5913995603364],
  [1715126400000, 3015.1597696166846],
  [1715212800000, 2975.72696606529],
  [1715299200000, 3038.3447046668207],
  [1715385600000, 2910.684500017475],
  [1715472000000, 2908.9827849031903],
  [1715558400000, 2931.3106669139133],
  [1715644800000, 2948.3034552659406],
  [1715731200000, 2881.7959916152945],
  [1715817600000, 3035.758955126304],
  [1715904000000, 2943.5851283842208],
  [1715990400000, 3095.9968442929658],
  [1716076800000, 3120.5493782541066],
  [1716163200000, 3071.324418093757],
  [1716249600000, 3656.390090299324],
  [1716336000000, 3792.486220211773],
  [1716422400000, 3741.897740560911],
  [1716508800000, 3766.398091341944],
  [1716595200000, 3727.065981583209],
  [1716681600000, 3750.077159389676],
  [1716768000000, 3825.277957577714],
  [1716854400000, 3893.3921058941055],
  [1716940800000, 3840.68886040005],
  [1717027200000, 3765.3025567780796],
  [1717113600000, 3748.6391523334596],
  [1717200000000, 3761.0692456476336],
  [1717286400000, 3813.452441559934],
  [1717372800000, 3780.7119847349145],
  [1717459200000, 3766.6376499412618],
  [1717545600000, 3814.932030146498],
  [1717632000000, 3871.0820906216727],
  [1717718400000, 3812.701856549199],
  [1717804800000, 3679.3766523741783],
  [1717891200000, 3683.0253801346485],
  [1717977600000, 3705.8998844045504],
  [1718064000000, 3666.8276647258203],
  [1718150400000, 3498.5559542215797],
  [1718236800000, 3559.4475336257624],
  [1718323200000, 3465.316584199481],
  [1718409600000, 3478.7748349889234],
  [1718496000000, 3565.1232591862595],
  [1718582400000, 3618.508652976102],
  [1718668800000, 3510.3586935289036],
  [1718755200000, 3480.4713384276088],
  [1718841600000, 3555.9658395535403],
  [1718928000000, 3511.28482815368],
  [1719014400000, 3516.88098000528],
  [1719100800000, 3494.7985621731755],
  [1719187200000, 3417.7971372978254],
  [1719273600000, 3357.1006400727606],
  [1719360000000, 3395.304687339692],
  [1719446400000, 3365.9446697083863],
  [1719532800000, 3442.910158110125],
  [1719619200000, 3374.6051303067916],
  [1719705600000, 3371.278227967461],
  [1719792000000, 3435.3183276337395],
  [1719878400000, 3438.009078999906],
  [1719964800000, 3417.8984255478363],
  [1720051200000, 3295.808464429979],
  [1720137600000, 3069.0434008340803],
  [1720224000000, 2984.398102498264],
  [1720310400000, 3066.247437954064],
  [1720396800000, 2928.6012310061665],
  [1720483200000, 3016.0833537946064],
  [1720569600000, 3064.0923605197886],
  [1720656000000, 3099.7101861313545],
  [1720742400000, 3102.0902302291074],
  [1720828800000, 3132.980838609695],
  [1720915200000, 3173.5042341380185],
  [1721001600000, 3252.654184707363],
  [1721088000000, 3488.5387580277174],
  [1721174400000, 3446.7658893041003],
  [1721260800000, 3389.441287038116],
  [1721347200000, 3428.5520187667257],
  [1721433600000, 3505.222536388452],
  [1721520000000, 3522.8013028122487],
  [1721606400000, 3533.118349531153],
  [1721692800000, 3443.073350817144],
  [1721779200000, 3482.9837705931927],
  [1721865600000, 3336.3802530382436],
  [1721952000000, 3173.7633983274727],
  [1722038400000, 3278.1869575279507],
  [1722124800000, 3254.611672582785],
  [1722211200000, 3272.8501306701373],
  [1722297600000, 3316.942188773212],
  [1722384000000, 3276.981779516743],
  [1722470400000, 3233.076804863122],
  [1722556800000, 3204.2465237463616],
  [1722643200000, 2983.300976694291],
  [1722729600000, 2906.7150241765007],
  [1722816000000, 2682.4373928187924],
  [1722902400000, 2415.6311394312143],
  [1722988800000, 2455.51137665051],
  [1723075200000, 2341.590346028249],
  [1723161600000, 2685.012750687489],
  [1723248000000, 2602.1840712761878],
  [1723334400000, 2608.0357436286963],
  [1723420800000, 2558.790870730736],
  [1723507200000, 2726.777988551933],
  [1723593600000, 2703.5505587641255],
  [1723680000000, 2662.780395092489],
  [1723766400000, 2569.8604812159274],
  [1723852800000, 2592.249006212312],
  [1723939200000, 2613.139261446099],
  [1724025600000, 2614.6012806263716],
  [1724112000000, 2640.5904207330605],
  [1724198400000, 2575.643435503567],
  [1724284800000, 2630.2988017642488],
  [1724371200000, 2623.289171364539],
  [1724457600000, 2763.2554073640704],
  [1724544000000, 2767.840733546234],
  [1724630400000, 2745.164671605207],
  [1724716800000, 2683.0801154902983],
  [1724803200000, 2457.2773517547434],
  [1724889600000, 2527.0269814017706],
  [1724976000000, 2526.7383553003406],
  [1725062400000, 2527.690204915795],
  [1725148800000, 2513.3643501004462],
  [1725235200000, 2430.0202661439344],
  [1725321600000, 2534.9048168403706],
  [1725408000000, 2437.1471557556497],
  [1725494400000, 2448.30785784089],
  [1725580800000, 2367.7700509506026],
  [1725667200000, 2223.780428382685],
  [1725753600000, 2272.6972849951912],
  [1725840000000, 2296.4029520764498],
  [1725926400000, 2359.565766831627],
  [1726012800000, 2389.4740111256497],
  [1726099200000, 2342.9639236941434],
  [1726185600000, 2362.300238174588],
  [1726272000000, 2445.08621032297],
  [1726358400000, 2418.0828083179904],
  [1726444800000, 2322.6433317480564],
  [1726531200000, 2295.1348386540835],
  [1726617600000, 2341.0924132597524],
  [1726704000000, 2361.960992100706],
  [1726790400000, 2465.2347833172967],
  [1726876800000, 2557.6218555442515],
  [1726963200000, 2614.599604753501],
  [1727049600000, 2582.847683741262],
  [1727136000000, 2647.9931622033255],
  [1727222400000, 2653.844345308008],
  [1727308800000, 2578.566359563475],
  [1727395200000, 2630.94983700893],
  [1727481600000, 2698.1928212346033]
]